import Vue from "vue";
import Vuex from "vuex";
import {getToken, getUser, setUser} from 'chaos-sso-util'
import api from "../../config/api";
import Bus from "../bus";
import axios from "axios";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    userName: "",
    user:undefined
  },

  mutations: {
    setUserName(state, userName) {
      state.userName = userName;
    },
    setUser(state,user){
      state.user = user
    }
  },
  actions: {
    getUserInfo({commit, state}){
      return new Promise((resolve,reject)=>{
        axios.get(api + `getSsoUser`, {
          headers: { 'Authorization': getToken() }
        }).then(res => {
          setUser(res)
          commit('setUserName', res.userName)
          commit('setUser', res)
          resolve(res)
        })
      })
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js